import { render, staticRenderFns } from "./Survey.vue?vue&type=template&id=66aa63e6&scoped=true&"
import script from "./Survey.vue?vue&type=script&lang=ts&"
export * from "./Survey.vue?vue&type=script&lang=ts&"
import style0 from "./Survey.vue?vue&type=style&index=0&id=66aa63e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66aa63e6",
  null
  
)

export default component.exports